import { http } from './http';

export interface ApiLog {
    id: number;
    timestamp: string;
    logLevel: number;
    logLevelName?: string;
    message: string;
    user?: string;
    source?: string;
}

export interface LogFilter {
    filtermessage?: string;
    filteruser?: string;
    minlevel?: number | null;
    fromdate?: string | null;
    todate?: string | null;
    skip?: number;
    take?: number;
}

export async function getLogs(filter: LogFilter): Promise<ApiLog[]> {
    const params = new URLSearchParams();
    if (filter.filtermessage) params.set('filtermessage', filter.filtermessage);
    if (filter.filteruser) params.set('filteruser', filter.filteruser);
    if (filter.minlevel != null) params.set('minlevel', String(filter.minlevel));
    if (filter.fromdate) params.set('fromdate', filter.fromdate);
    if (filter.todate) params.set('todate', filter.todate);
    params.set('skip', String(filter.skip ?? 0));
    params.set('take', String(filter.take ?? 200));

    return http<ApiLog[]>(`/api/log?${params.toString()}`, { auth: true });
}